/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */
import { v4 as uuidv4 } from "uuid";
require("./bootstrap");
import App from "./App";
import { store } from "./store";
import { router } from "./router";
import KrAuth from "./components/auth/auth.js";
import * as Sentry from "@sentry/vue";
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE ? parseFloat(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE):1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: process.env.VUE_APP_REPLAYS_SESSION_SAMPLE_RATE ? parseFloat(process.env.VUE_APP_REPLAYS_SESSION_SAMPLE_RATE):0.1,
  replaysOnErrorSampleRate: process.env.VUE_APP_REPLAYS_ON_ERROR_SAMPLE_RATE ? parseFloat(process.env.VUE_APP_REPLAYS_ON_ERROR_SAMPLE_RATE):0.1,
});
if (process.env.VUE_APP_DEV_TOOLS == "false") {
  Vue.config.devtools = false;
} else {
  Vue.config.devtools = true;
}
window.app = new Vue({
  render: (h) => h(App),
  data() {
    let auth = new KrAuth();
    return {
      auth: auth,
    };
  },
  router: router,
  store: store,
  created() {
    this.$store.dispatch("setSessionUuid", uuidv4());
  },
  mounted() {
    var that = this;
    //Login,Logout, And Refresh User Information Events
    if(this.auth.isLoggedIn()){
      Sentry.setUser({userUuid:this.auth.user().uuid});
    }
    if (
      this.auth.isLoggedIn() &&
      this.auth.user().role == "Student" &&
      this.$route.name != "checkout-success"
    ) {
      axios.get("student/current-status").then(function(response) {});
    }
    Events.listen("getUserInformation", () => {
      this.getUserInformation();
    });
    Events.listen("login-successful", (options) => {
      this.setMomentOffset(this.auth.credential().serverTimeOnLogin);

      if (this.auth.isLoggedIn()) {
        axios.defaults.baseURL = this.auth.credential().API_URL;
        Sentry.setUser({userUuid:this.auth.user().uuid});
      } 
      this.$router.push({ name: "tests.proper",params:{id:this.auth.user().test.testTratUuid}});
    });
    Events.listen("logout", (options = {}) => {
      this.logout(options);
    });
    Events.listen("impersonate-logout-successful", () => {
      if (this.auth.user().role == "Superuser") {
        this.$router.push({ name: "accounts.index" });
      }
    });
    Events.listen("logout-successful", (options = {}) => {
      Sentry.setUser(null);
        this.$router.push({name:'auth.demo'})
    });
    var highlightingColor = window.localStorage.getItem("highlightColor");
    if (highlightingColor == "#17244A") {
      document.documentElement.style.setProperty(
        "--dark-highlight-color",
        "#fff"
      );
    } else {
      document.documentElement.style.setProperty(
        "--dark-highlight-color",
        "#222"
      );
    }
    document.documentElement.style.setProperty(
      "--highlight-color",
      highlightingColor
    );
  },
  methods: {
    logout(options = {}) {
      if (options.from != "AXIOS_401") {
        if (!this.auth.isImpersonation()) {
          axios
            .get("/profile/sign-out")
            .then(function(response) {})
            .catch(function(errors) {});
        } else {
          axios
            .post(
              `auth/invalidate?impersonate&impersonator=${
                this.auth.user(true).uuid
              }`
            )
            .then(function(response) {})
            .catch(function(errors) {});
        }
      }
      this.auth.logout();
    },
  },
}).$mount("#app");
